import { Dispatch } from 'redux'
import { NotificationManager } from 'helpers/NotificationsManager'
import {
  IGetNotificationsParams,
  IGetNotificationsThunkParams,
  NOTIFICATION_STATUS,
} from 'models/Notification'
import { API } from 'network'
import {
  UpdateAllNotificationsStatus,
  UpdateNotification,
  DeleteNotification,
} from 'data/upshifter/Notifications/actions'
import {
  ClearUnreadNotifications,
  DeleteUnreadNotification,
  GetUnreadNotifications as GetUnreadNotificationsAction,
  GetUnreadNotificationsErrors,
  GetUnreadNotificationsWithoutConcat,
  UnreadNotificationsFetching,
  UpdateUnreadNotification,
} from './actions'

export type UnreadNotificationsActions =
  | ReturnType<typeof GetUnreadNotificationsAction>
  | ReturnType<typeof GetUnreadNotificationsWithoutConcat>
  | ReturnType<typeof GetUnreadNotificationsErrors>
  | ReturnType<typeof UnreadNotificationsFetching>
  | ReturnType<typeof ClearUnreadNotifications>
  | ReturnType<typeof UpdateAllNotificationsStatus>
  | ReturnType<typeof UpdateNotification>
  | ReturnType<typeof DeleteNotification>
  | ReturnType<typeof DeleteUnreadNotification>
  | ReturnType<typeof UpdateUnreadNotification>

export const getUnreadNotifications = ({
  params,
  preventConcatenate,
}: IGetNotificationsThunkParams) => async (
  dispatch: Dispatch<UnreadNotificationsActions>,
) => {
  let response = null
  const newParams: IGetNotificationsParams = {
    ...params,
    status: NOTIFICATION_STATUS.NOT_READ,
  }
  try {
    response = await API.Notifications.getNotifications(newParams)
    if (preventConcatenate) {
      dispatch(GetUnreadNotificationsWithoutConcat(response))
    } else {
      dispatch(GetUnreadNotificationsAction(response))
    }
  } catch (error) {
    dispatch(
      GetUnreadNotificationsErrors({
        code: error.code,
        message: error.message,
      }),
    )
    NotificationManager.error(
      'A problem occurred while getting the Notifications.',
    )
  }
  return response
}

export const readNotifications = () => async (
  dispatch: Dispatch<UnreadNotificationsActions>,
) => {
  dispatch(UnreadNotificationsFetching(true))
  let response = null
  try {
    response = await API.Notifications.readNotifications()
    dispatch(UpdateAllNotificationsStatus())
    dispatch(ClearUnreadNotifications())
  } catch (error) {
    dispatch(
      GetUnreadNotificationsErrors({
        code: error.code,
        message: error.message,
      }),
    )
    NotificationManager.error(
      'A problem occurred while reading the Notifications.',
    )
  } finally {
    dispatch(UnreadNotificationsFetching(false))
  }
  return response
}

export const readNotification = (id: number) => async (
  dispatch: Dispatch<UnreadNotificationsActions>,
) => {
  let response = null
  try {
    response = await API.Notifications.putNotification(id, {
      status: NOTIFICATION_STATUS.READ,
    })
    dispatch(UpdateNotification(response))
    dispatch(DeleteUnreadNotification(id))
  } catch (error) {
    dispatch(
      GetUnreadNotificationsErrors({
        code: error.code,
        message: error.message,
      }),
    )
    NotificationManager.error(
      'A problem occurred while reading the Notification.',
    )
  }
  return response
}

export const deleteNotification = (id: number) => async (
  dispatch: Dispatch<UnreadNotificationsActions>,
) => {
  let response = null
  try {
    response = await API.Notifications.deleteNotification(id)
    dispatch(DeleteNotification(id))
    dispatch(DeleteUnreadNotification(id))
  } catch (error) {
    dispatch(
      GetUnreadNotificationsErrors({
        code: error.code,
        message: error.message,
      }),
    )
    NotificationManager.error(
      'A problem occurred while deleting the Notification.',
    )
  }
  return response
}

export const clearUnreadNotifications = () => (
  dispatch: Dispatch<UnreadNotificationsActions>,
) => {
  dispatch(ClearUnreadNotifications())
}
